
(function ($, document) {

    $(document).ready(function () {
        $(document).on('click', ".js-submit-once", function () {
            var isValid = true;
            if (typeof Page_ClientValidate == 'function') {
                isValid = Page_ClientValidate($(this).data("vgroup"));
            }
            if (isValid) {
                $(this).after("Please wait...").hide();
            }
        });
    });
})(jQuery, document);